import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ColorsModule } from '@plugins/client/colors/colors.module';

import { ButtonComponent } from './button.component';

@NgModule({
  imports: [CommonModule, ColorsModule],
  declarations: [ButtonComponent],
  exports: [ButtonComponent],
})
export class ButtonModule {}
export { ButtonComponent };
